import NewGroupModal from "./NewGroupModal"

export default  NewGroupModal;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/NewGroupModal/index.js